import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { AppRoutes } from './AppRoutes';

const HomePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div>
      <h1>IF DEPLOY IS CORRECT THIS MESSAGE SHOULD APPEAR</h1>,
      {(Object.keys(AppRoutes) as Array<keyof typeof AppRoutes>).map((key) => {
        return (
          <Button key={key} onClick={() => navigate(AppRoutes[key])}>
            {t('common.Actions.NavigateTo', {
              defaultValue: 'Navigate to {{key}}',
              key,
            })}
          </Button>
        );
      })}
      <button
        type="button"
        onClick={() => {
          throw new Error('This is your first error!');
        }}
      >
        {t('common.Actions.BreakWorld', { defaultValue: 'Break the world' })}
      </button>
      ;
    </div>
  );
};
export default HomePage;
